export default __webpack_public_path__ + "static/media/Missionary's Boots.2b226589.jpg";